//angular references
import { Component, Inject, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

//BusinessEvent control references
import { BEDataService } from '../../services/businessEvent/beData.service';
import { BEWorkflowSteps } from '../../services/businessEvent/beWorkflow.model';

//Config references
import { ConfigDataService, enumClientConfig, enumUIConfig, enumValidationMode } from '../../services/configuration/configData.service';

//Era model references
import { BusinessEvent, enumBusinessEventMode, enumBusinessEventAction } from '../../models/businessevent.model';
import { OTA_Charge } from '../../models/ota_charge.model';
import { OTA_PricedEquip } from '../../models/ota_pricedequip.model';
import { OTA_Fee } from '../../models/ota_fee.model';
import { OTA_PricedCoverage } from '../../models/ota_pricedcoverage.model';
import { CurrencyAmount } from '../../models/currencyamount.model';
import { Identification, enumIdentType, enumIdentStatus } from '../../models/identification.model';
import { Phone, enumPhoneType } from '../../models/phone.model';
import { Address, enumAddressType } from '../../models/address.model';
import { OTA_VehAvail } from '../../models/ota_vehavail.model';
import { OTA_Request, enumRequestType } from '../../models/ota_request.model';
import { OTA_Response } from '../../models/ota_response.model';
import { OTA_VehPref } from '../../models/ota_vehpref.model';
import { OTA_VehType } from '../../models/ota_vehtype.model';
import { OTA_SpecialEquipPref } from '../../models/ota_specialequippref.model';
import { OTA_CoveragePref } from '../../models/ota_coveragepref.model';
import { enumPromotionType } from '../../models/promotiontype.model';
import { KeyValuePair } from '../../models/keyvaluepair.model';
import { Dialog } from '../../models/dialog.model';
import { DialogButton, enumDialogButtonType } from '../../models/dialogButton.model';
import { OTA_Error } from '../../models/ota_error.model';
import { enumCallStatus } from '../../models/callStatus.model';
import { OTA_OffLocService } from '../../models/ota_offlocservice.model';

//dialog references
import { ConfirmationService } from 'primeng/api';

enum enumAsyncLoad {
    OTAResponse = 1,
    UIConfigs = 2,
    ClientConfigs = 3,
};

@Component({
    selector: 'beReview',
    template: require('./beReview.component.html'),
    styles: [require('../app/app.component.css')]
})
export class BEReviewComponent {
    //page/workflow 
    private _title = 'Review your booking';
    private _currentStep = BEWorkflowSteps.beReview;
    private _nextStep = "";
    private _previousStep = "";
    private _subscriptions: Subscription[] = [];

    private _font: string = "";
    private _textColour: string = "";
    private _invalidTextColour: string = "";
    private _invalidBorderColour: string = "";
    private _containerBackColour: string = "";
    private _containerBorderColour: string = "";
    private _containerCornerRadius: string = "";
    private _inactiveTabColour: string = "";
    private _containerBorderFull: string = "";

    private _firstNameTextColour: string = "";
    private _firstNameBorderColour: string = "";
    private _lastNameTextColour: string = "";
    private _lastNameBorderColour: string = "";
    private _dobTextColour: string = "";
    private _dobBorderColour: string = "";
    private _emailTextColour: string = "";
    private _emailBorderColour: string = "";
    private _phoneTextColour: string = "";
    private _phoneBorderColour: string = "";
    private _addressLineTextColour: string = "";
    private _addressLineBorderColour: string = "";
    private _addressCityTextColour: string = "";
    private _addressCityBorderColour: string = "";
    private _addressStateTextColour: string = "";
    private _addressStateBorderColour: string = "";
    private _addressZipCodeTextColour: string = "";
    private _addressZipCodeBorderColour: string = "";
    private _arrivalTextColour: string = "";
    private _arrivalBorderColour: string = "";
    private _dlNumberTextColour: string = "";
    private _dlNumberBorderColour: string = "";
    private _dlExpiryTextColour: string = "";
    private _dlExpiryBorderColour: string = "";

    private _commandButtonFont: string = "";
    private _commandButtonRadius: string = "";
    private _commandButtonTextSize: string = "";
    private _commandButtonTextWeight: string = "";
    private _primaryCommandButtonTextColour: string = "";
    private _primaryCommandButtonBackColour: string = "";
    private _primaryCommandButtonBorderFull: string = "";
    private _secondaryCommandButtonTextColour: string = "";
    private _secondaryCommandButtonBackColour: string = "";
    private _secondaryCommandButtonBorderFull: string = "";
    private _checkboxTickColour: string = "";
    private _checkboxTickedBackColour: string = "";
    private _checkboxUntickedBackColour: string = "";
    private _checkboxBorderColour: string = "";

    private _dividerLineColour: string = "";

    private _showSubscribe: boolean = false;
    private _showDOB: boolean = false;
    private _showDL: boolean = false;
    private _showAddress: boolean = true;
    private _mandatoryDOB: boolean = false;
    private _mandatoryDL: boolean = false;
    private _mandatoryAddress: boolean = false;
    
    private _baseVehImgURL = "/img/vehicleImages/";
    private _validationMode: enumValidationMode = enumValidationMode.valmode_Immediate;

    //loaded 
    private _fullyLoaded: boolean = false;
    private _loadingErrorMsgs: string[] = new Array();
    private _loaded = [
        {
            step: enumAsyncLoad.OTAResponse,
            loaded: false,
        },
        {
            step: enumAsyncLoad.UIConfigs,
            loaded: false,
        },
        {
            step: enumAsyncLoad.ClientConfigs,
            loaded: false,
        },
    ];

    //business event parameters
    private _be: BusinessEvent;
    private _otaResponse: OTA_Response;
    private _otaAvail: OTA_VehAvail;
    private _otaPricedCoverage: OTA_PricedCoverage;
    private _locationOut: string = "";
    private _locationIn: string = "";
    private _dateTimeOut: string;
    private _dateTimeIn: string;
    private _firstName: string = "";
    private _lastName: string = "";
    private _email: string = "";
    private _confirmEmail: string = "";
    private _phoneNumber: string = "";
    private _arrivalNo: string = "";
    private _addressLine: string = "";
    private _addressCity: string = "";
    private _addressState: string = "";
    private _addressZipCode: string = "";
    private _emailIdentification: Identification;
    private _phone: Phone;
    private _address: Address;
    private _selectedVehicle: OTA_VehAvail;
    private _emailSubscription: boolean = false;
    private _isNew: boolean = true;
    private _rentalChanged: boolean = false;
    private _deliveryAddress: string = "";
    private _collectionAddress: string = "";
    private _reference: string = "";
    private _dlNumber: string = "";
    private _dlExpiry: string;
    private _dlIdentification: Identification;
    private _dob: string;

    //lists
    private _otaCharges: OTA_Charge[];
    private _otaPricedEquips: OTA_PricedEquip[];
    private _otaFees: OTA_Fee[];
    private _otaFeesNotIncluded: OTA_Fee[];
    private _otaPricedCoverages: OTA_PricedCoverage[];
    private _totalCosts = new Array<CurrencyAmount>();

    //error/change tracking
    private _hasChanged: boolean = false;
    private _hasError: boolean = false;
    private _hasFirstNameError: boolean = false;
    private _hasLastNameError: boolean = false;
    private _hasDOBError: boolean = false;
    private _hasEmailError: boolean = false;
    private _hasPhoneNumberError: boolean = false;
    private _hasAddressLineError: boolean = false;
    private _hasAddressCityError: boolean = false;
    private _hasAddressStateError: boolean = false;
    private _hasAddressZipCodeError: boolean = false;
    private _hasArrivalNumberError: boolean = false;
    private _hasDLError: boolean = false;
    private _hasDLExpiryError: boolean = false;
    private _doValidation: boolean = false;
    private _hasSubmitError: boolean = false;
    private _validationErrorMsgs: string[] = new Array();

    //dialog
    private _dialog: Dialog = new Dialog();

    private _firstNameCaption: string = "First name";
    private _lastNameCaption: string = "Last name";
    private _emailCaption: string = "Email";
    private _phoneNumberCaption: string = "Phone number";
    private _addressLineCaption: string = "Address";
    private _addressCityCaption: string = "City";
    private _addressStateCaption: string = "State";
    private _addressZipCodeCaption: string = "Post Code";
    private _dateOfBirthCaption: string = "Date of Birth";

    //helpers
    private _todaysDate = new Date().toISOString().split('T')[0];

    //
    //component events
    //
    public constructor(private _router: Router,
        private _beDataService: BEDataService,
        private _configDataService: ConfigDataService,
        private _httpClient: HttpClient,
        @Inject('BASE_URL') private _baseUrl: string,
        private _confirmationService: ConfirmationService)
    {
        this._nextStep = this._beDataService.nextStep(this._currentStep);
        this._previousStep = this._beDataService.previousStep(this._currentStep);
    }

    private async ngOnInit()
    {
        //get the current BusinessEvent's Review data
        this._be = this._beDataService.getBusinessEventForStep(this._currentStep);

        if (this._be.refresh) {
            //the equips/coverages were changed on the previous page, so do a new availability request to get the updated charges
            //construct the OTA Request object for the current business event
            let otaReq: OTA_Request = this.createOTARequest();

            //get the OTA Available response for the current BusinessEvent's vehicle and equip/coverage
            this._httpClient.get<OTA_Response>(this._baseUrl + 'api/OTAData/OTARequest?'
                + '&otaReqJSON=' + JSON.stringify(otaReq)).subscribe(result => {
                    this._otaResponse = result;
                    this._otaAvail = result.otA_VehAvailRateRS.vehAvailRSCore.vehVendorAvails[0].vehAvails[0];
                    this.saveOTAAvail();
                    this.asyncLoaded(enumAsyncLoad.OTAResponse);
                }, error => console.error(error));

        }
        else {
            this._otaAvail = this._be.otaVehAvail;
            this.asyncLoaded(enumAsyncLoad.OTAResponse);
        }

        //get the configured UIConfigs
        if (this._configDataService.uiConfigs == null) {
            this._httpClient.get<KeyValuePair[]>(this._baseUrl + 'api/ConfigData/UIConfigs').subscribe(result => {
                this._configDataService.uiConfigs = result;
                this.asyncLoaded(enumAsyncLoad.UIConfigs);
            }, error => console.error(error));
        }
        else
            this.asyncLoaded(enumAsyncLoad.UIConfigs);

        this._subscriptions.push(this._beDataService.invokeSaveFirst.subscribe(step => {
            this.goToPrevious(step);
        }));

        //get the configured ClientConfigs
        if (this._configDataService.clientConfigs == null) {
            this._httpClient.get<KeyValuePair[]>(this._baseUrl + 'api/ConfigData/ClientConfigs').subscribe(result => {
                this._configDataService.clientConfigs = result;
                this.asyncLoaded(enumAsyncLoad.ClientConfigs);
            }, error => console.error(error));
        }
        else
            this.asyncLoaded(enumAsyncLoad.ClientConfigs);
    }

    private async ngOnDestroy() {
        //clear out any subscriptions
        this.unsubscribe();
    };

    //private async ngDoCheck() {
    private async ngAfterViewChecked() {
        //style the checkboxes based on their state
        if ((this._checkboxTickColour.length > 0)
            || (this._checkboxTickedBackColour.length > 0)
            || (this._checkboxUntickedBackColour.length > 0)
            || (this._checkboxBorderColour.length > 0)) {

            //default with unticked style
            var checkboxes = document.getElementsByClassName('ui-chkbox-box') as HTMLCollectionOf<HTMLElement>;
            Array.from(checkboxes).forEach(checkbox => {
                checkbox.style.backgroundColor = this._checkboxUntickedBackColour;
                checkbox.style.borderColor = this._checkboxBorderColour;
            });

            //apply ticked style to any ticked checkboxes
            var tickedCheckboxes = document.getElementsByClassName('ui-chkbox-box ui-state-active') as HTMLCollectionOf<HTMLElement>;
            Array.from(tickedCheckboxes).forEach(checkbox => {
                checkbox.style.backgroundColor = this._checkboxTickedBackColour;
                checkbox.style.color = this._checkboxTickColour;
            });
        }
    }

    //
    //component management
    //
    private asyncLoaded(step: enumAsyncLoad) {
        let fullyLoaded: boolean = true;

        for (var i = 0; i < this._loaded.length; i++) {
            if (this._loaded[i].step === step) {
                //record the given step as being loaded
                this._loaded[i].loaded = true;
            }
            else if (!this._loaded[i].loaded) {
                //check if all async steps have been loaded
                fullyLoaded = false;
            }
        }

        switch (step) {
            case enumAsyncLoad.UIConfigs:
                let font: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_Font);
                let textColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_TextColour);
                let invalidTextColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_InvalidTextColour);
                let invalidBorderColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_InvalidControlBorderColour);
                let containerBackColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_ContainerBackgroundColour);
                let containerBorderColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_ContainerBorderColour);
                let containerCornerRadius: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_ContainerCornerRadius);
                let inactiveTabColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_InactiveTabColour);
                let containerBorderStyle: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_ContainerBorderStyle);

                let commandButtonFont: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_CommandButtonFont);
                let commandButtonRadius: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_CommandButtonRadius);
                let commandButtonTextSize: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_CommandButtonTextSize);
                let commandButtonTextWeight: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_CommandButtonTextWeight);
                let primaryCommandButtonTextColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_PrimaryCommandButtonTextColour);
                let primaryCommandButtonBackColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_PrimaryCommandButtonBackgroundColour);
                let primaryCommandButtonBorderColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_PrimaryCommandButtonBorderColour);
                let primaryCommandButtonBorderStyle: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_PrimaryCommandButtonBorderStyle);

                let secondaryCommandButtonTextColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_SecondaryCommandButtonTextColour);
                let secondaryCommandButtonBackColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_SecondaryCommandButtonBackgroundColour);
                let secondaryCommandButtonBorderColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_SecondaryCommandButtonBorderColour);
                let secondaryCommandButtonBorderStyle: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_SecondaryCommandButtonBorderStyle);

                let checkboxTickColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_CheckboxTickColour);
                let checkboxTickedBackColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_CheckboxTickedBackColour);
                let checkboxUntickedBackColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_CheckboxUntickedBackColour);
                let checkboxBorderColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_CheckboxBorderColour);

                let dividerLineColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_DividerLineColour);

                let validationMode: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_ValidationMode);

                let firstNameCaption: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_FirstNameCaption);
                let lastNameCaption: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_LastNameCaption);
                let emailCaption: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_EmailCaption);
                let phoneNumberCaption: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_PhoneNumberCaption);
                let dateOfBirthCaption: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_DateOfBirthCaption);
                let addressLineCaption: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_AddressLineCaption);
                let addressStateCaption: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_AddressStateCaption);
                let addressCityCaption: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_AddressCityCaption);
                let addressZipCodeCaption: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_AddressZipCodeCaption);

                if (font.trim().length > 0) {
                    this._font = font;
                }
                if (textColour.trim().length > 0) {
                    this._textColour = textColour;
                }
                if (invalidTextColour.trim().length > 0) {
                    this._invalidTextColour = invalidTextColour;
                }
                if (invalidBorderColour.trim().length > 0) {
                    this._invalidBorderColour = invalidBorderColour;
                }
                if (containerBackColour.trim().length > 0) {
                    this._containerBackColour = containerBackColour;
                }
                if (containerBorderColour.trim().length > 0) {
                    this._containerBorderColour = containerBorderColour;
                }
                if (containerCornerRadius.trim().length > 0) {
                    this._containerCornerRadius = containerCornerRadius;
                }
                if (inactiveTabColour.trim().length > 0) {
                    this._inactiveTabColour = inactiveTabColour;
                }
                if ((containerBorderStyle.trim().length > 0)
                    || (containerBorderColour.trim().length > 0)) {
                    this._containerBorderFull = containerBorderColour + " " + containerBorderStyle;
                }

                if (commandButtonFont.trim().length > 0) {
                    this._commandButtonFont = commandButtonFont;
                }
                if (commandButtonRadius.trim().length > 0) {
                    this._commandButtonRadius = commandButtonRadius;
                }
                if (commandButtonTextSize.trim().length > 0) {
                    this._commandButtonTextSize = commandButtonTextSize;
                }
                if (commandButtonTextWeight.trim().length > 0) {
                    this._commandButtonTextWeight = commandButtonTextWeight;
                }
                if (primaryCommandButtonTextColour.trim().length > 0) {
                    this._primaryCommandButtonTextColour = primaryCommandButtonTextColour;
                }
                if (primaryCommandButtonBackColour.trim().length > 0) {
                    this._primaryCommandButtonBackColour = primaryCommandButtonBackColour;
                }
                if ((primaryCommandButtonBorderStyle.trim().length > 0)
                    || (primaryCommandButtonBorderColour.trim().length > 0)) {
                    this._primaryCommandButtonBorderFull = primaryCommandButtonBorderColour + " " + primaryCommandButtonBorderStyle;
                }
                if (secondaryCommandButtonTextColour.trim().length > 0) {
                    this._secondaryCommandButtonTextColour = secondaryCommandButtonTextColour;
                }
                if (secondaryCommandButtonBackColour.trim().length > 0) {
                    this._secondaryCommandButtonBackColour = secondaryCommandButtonBackColour;
                }
                if ((secondaryCommandButtonBorderStyle.trim().length > 0)
                    || (secondaryCommandButtonBorderColour.trim().length > 0)) {
                    this._secondaryCommandButtonBorderFull = secondaryCommandButtonBorderColour + " " + secondaryCommandButtonBorderStyle;
                }
                if (checkboxTickColour.trim().length > 0) {
                    this._checkboxTickColour = checkboxTickColour;
                }
                if (checkboxTickedBackColour.trim().length > 0) {
                    this._checkboxTickedBackColour = checkboxTickedBackColour;
                }
                if (checkboxUntickedBackColour.trim().length > 0) {
                    this._checkboxUntickedBackColour = checkboxUntickedBackColour;
                }
                if (checkboxBorderColour.trim().length > 0) {
                    this._checkboxBorderColour = checkboxBorderColour;
                }

                if (dividerLineColour.trim().length > 0) {
                    this._dividerLineColour = dividerLineColour;
                }

                if (validationMode.trim().length > 0) {

                    switch (validationMode.trim()) {
                        case "1":
                            this._validationMode = enumValidationMode.valmode_OnPageSubmit;
                            break;

                        default:
                            this._validationMode = enumValidationMode.valmode_Immediate;
                            break;
                    }
                }

                if (firstNameCaption.trim().length > 0) {
                    this._firstNameCaption = firstNameCaption;
                }
                if (lastNameCaption.trim().length > 0) {
                    this._lastNameCaption = lastNameCaption;
                }
                if (emailCaption.trim().length > 0) {
                    this._emailCaption = emailCaption;
                }
                if (phoneNumberCaption.trim().length > 0) {
                    this._phoneNumberCaption = phoneNumberCaption;
                }
                if (dateOfBirthCaption.trim().length > 0) {
                    this._dateOfBirthCaption = dateOfBirthCaption;
                }
                if (addressLineCaption.trim().length > 0) {
                    this._addressLineCaption = addressLineCaption;
                }
                if (addressCityCaption.trim().length > 0) {
                    this._addressCityCaption = addressCityCaption;
                }
                if (addressStateCaption.trim().length > 0) {
                    this._addressStateCaption = addressStateCaption;
                }
                if (addressZipCodeCaption.trim().length > 0) {
                    this._addressZipCodeCaption = addressZipCodeCaption;
                }

                break;

            case enumAsyncLoad.ClientConfigs:
                var baseVehImgURL = "/img/vehicleImages/";
                let configVehImgURL: string = this._configDataService.getClientConfig(enumClientConfig.cconf_VehicleImageFolder, baseVehImgURL);
                if (configVehImgURL.trim().length > 0) {
                    this._baseVehImgURL = configVehImgURL;
                }

                this._showSubscribe = (this._configDataService.getClientConfig(enumClientConfig.cconf_ShowSubscribe) == "1");
                this._showDOB = (this._configDataService.getClientConfig(enumClientConfig.cconf_ShowDOB) == "1");
                this._showDL = (this._configDataService.getClientConfig(enumClientConfig.cconf_ShowDL) == "1");
                this._showAddress = (this._configDataService.getClientConfig(enumClientConfig.cconf_ShowAddress) == "1");
                this._mandatoryDOB = ((this._configDataService.getClientConfig(enumClientConfig.cconf_MandatoryDOB) == "1") && this._showDOB);
                this._mandatoryDL = ((this._configDataService.getClientConfig(enumClientConfig.cconf_MandatoryDL) == "1") && this._showDL);
                this._mandatoryAddress = ((this._configDataService.getClientConfig(enumClientConfig.cconf_MandatoryAddress) == "1") && this._showAddress);

                this._showAddress == true

                break;
        }

        this._fullyLoaded = fullyLoaded;

        if (fullyLoaded) {
            //get the current BusinessEvent's data
            this.loadBusinessEvent();
        }
    }

    private loadBusinessEvent() {
        let errors: OTA_Error[] = new Array<OTA_Error>();
        const millisecondsPerMinute = 60000;

        var offsetTodaysDate: Date = new Date((new Date()).valueOf() - ((new Date()).getTimezoneOffset() * millisecondsPerMinute));
        this._todaysDate = offsetTodaysDate.toISOString().split('T')[0];

        if (this._otaAvail == null) {
            let otaError: OTA_Error = new OTA_Error();
            otaError.shortText = "No response received";
            errors.push(otaError);
        }
        else {
            if (this._otaResponse != null) {
                if ((this._otaResponse.callStatus != null)
                    && (this._otaResponse.callStatus.code != enumCallStatus.csStatus_OK)) {

                    let otaError: OTA_Error = new OTA_Error();
                    otaError.shortText = "Error - " + this._otaResponse.callStatus.code.toString();
                    //TODO specific messages per CallStatus code?
                    errors.push(otaError);
                }
                else {
                    if ((this._otaResponse.otA_VehAvailRateRS.errors != null)
                        && (this._otaResponse.otA_VehAvailRateRS.errors.length > 0)) {

                        errors = this._otaResponse.otA_VehAvailRateRS.errors;
                    }
                    else {
                        if ((this._otaResponse.otA_VehAvailRateRS.vehAvailRSCore.vehVendorAvails == null)
                            || (this._otaResponse.otA_VehAvailRateRS.vehAvailRSCore.vehVendorAvails.length == 0)
                            || (this._otaResponse.otA_VehAvailRateRS.vehAvailRSCore.vehVendorAvails[0].vehAvails == null)
                            || (this._otaResponse.otA_VehAvailRateRS.vehAvailRSCore.vehVendorAvails[0].vehAvails.length == 0)) {

                            let otaError: OTA_Error = new OTA_Error();
                            otaError.shortText = "There are no results";
                            //TODO specific messages per CallStatus code?
                            errors.push(otaError);
                        }
                    }
                }
            }
        }

        if (errors.length > 0) {
            //errors, so inform the user, and take them back to the previous page
            for (var otaErr in errors) {
                this._loadingErrorMsgs.push(errors[otaErr].shortText);
            }
        }
        else {
            this._locationOut = this._be.locationOut.description;
            this._locationIn = this._be.locationIn.description;
            this._deliveryAddress = this._be.deliveryAddress;
            this._collectionAddress = this._be.collectionAddress;

            var dateOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
            var timeOptions = { hour: 'numeric', minute: '2-digit' };
            this._dateTimeOut = ((this._be.dateTimeOut == null) ? "<unknown>" :
                this._be.dateTimeOut.toLocaleDateString(navigator.language, dateOptions)
                + " at " +  this._be.dateTimeOut.toLocaleTimeString(navigator.language, timeOptions))
            this._dateTimeIn = ((this._be.dateTimeIn == null) ? "<unknown>" :
                this._be.dateTimeIn.toLocaleDateString(navigator.language, dateOptions)
                + " at " + this._be.dateTimeIn.toLocaleTimeString(navigator.language, timeOptions));

            this._firstName = this._be.rentingentity.firstName;
            this._lastName = this._be.rentingentity.principalName;
            this._selectedVehicle = this._otaAvail;

            this._dob = "";
            if (this._be.rentingentity.dateofBirth != null) {
                var offsetDOB: Date = new Date(this._be.rentingentity.dateofBirth.valueOf());
                var isoDOB = offsetDOB.toISOString();
                this._dob = isoDOB.split('T')[0];
            }

            //get the first valid email Identification
            var emailIdentification = this._be.rentingentity.identList.find(x => ((x.identType == enumIdentType.idType_Email) && (x.identStatus == enumIdentStatus.idStatus_Valid)));
            if (emailIdentification != null) {
                this._emailIdentification = emailIdentification;

                this._email = emailIdentification.membershipNumber;
                this._confirmEmail = emailIdentification.membershipNumber;
                this._emailSubscription = emailIdentification.allowNotification;
            }

            //get the first valid DL Identification
            this._dlExpiry = "";
            var dlIdentification = this._be.rentingentity.identList.find(x => ((x.identType == enumIdentType.idType_DriversLicense) && (x.identStatus == enumIdentStatus.idStatus_Valid)));
            if (dlIdentification != null) {
                this._dlIdentification = dlIdentification;

                this._dlNumber = dlIdentification.membershipNumber;
                if (dlIdentification.expiry != null) {
                    var offsetDLExpiry: Date = new Date(dlIdentification.expiry.valueOf() );
                    var isoDLExpiry = offsetDLExpiry.toISOString();
                    this._dlExpiry = isoDLExpiry.split('T')[0];
                }
            }

            //get the first valid phone number
            var phone = this._be.rentingentity.phoneList.find(x => (x.phoneType == enumPhoneType.phnTypeContacts));
            if (phone != null) {
                this._phone = phone;
                this._phoneNumber = phone.phoneNumber;
            }

            //get the first valid address
            this._addressLine = "";
            this._addressCity = "";
            this._addressState = "";
            this._addressZipCode = "";
            if (this._be.rentingentity.address != null) {
                this._addressLine = this._be.rentingentity.address.addressLine1;
                this._addressCity = this._be.rentingentity.address.city;
                this._addressState = this._be.rentingentity.address.state;
                this._addressZipCode = this._be.rentingentity.address.zipCode;
            }

            this._be.locationOut.isAirport = this._be.locationOut.isAirport;
            this._arrivalNo = this._be.flightNumber;

            this._otaCharges = this._otaAvail.vehAvailCore.rentalRate.vehCharges;
            this._otaPricedEquips = this._otaAvail.vehAvailCore.pricedEquips.filter(eq => eq.charge.includedInEstTotalInd);
            this._otaFees = this._otaAvail.vehAvailCore.fees.filter(f => f.includedInEstTotalInd);
            this._otaFeesNotIncluded = this._otaAvail.vehAvailCore.fees.filter(f => ((!f.includedInEstTotalInd) && (this._configDataService.showAdditionalFee(f))));
            this._otaPricedCoverages = this._otaAvail.vehAvailInfo.pricedCoverages;

            //get the currently selected Coverage
            if (this._otaPricedCoverages.length > 0) {
                for (var i = 0; i < this._otaPricedCoverages.length; i++) {
                    let cvr = this._otaPricedCoverages[i];

                    if ((cvr.charge.includedInEstTotalInd) && (!cvr.charge.includedInRate)) {
                        this._otaPricedCoverage = cvr;
                        break;
                    }
                    else if (cvr.charge.includedInRate) 
                        this._otaPricedCoverage = cvr;
                }
            }
        
            ////calculate the total cost
            ////total the rental charges
            var ttlAmount = this._otaAvail.vehAvailCore.totalCharge.estimatedTotalAmount;
            if (this._be.payNow) {
                for (var chrg in this._otaCharges) {
                    if (this._otaCharges[chrg].calculations != null) {
                        this._otaCharges[chrg].calculations.forEach(function (calc) {
                            ttlAmount = ttlAmount - (calc.total * 0.1);
                        });
                    }
                }
            }
            this.totalCurrencyCost(this._otaAvail.vehAvailCore.totalCharge.currencyCode, ttlAmount);
            //for (var chrg in this._otaCharges) {
            //    this.totalCurrencyCost(this._otaCharges[chrg].currencyCode, this._otaCharges[chrg].calculation.total);
            //}
            ////total the fees
            //for (var fee in this._otaFees) {
            //    if (!this._otaFees[fee].includedInRate)
            //        this.totalCurrencyCost(this._otaFees[fee].currencyCode, this._otaFees[fee].calculation.total);
            //}

            ////total the coverage
            //this.totalCurrencyCost(this._otaPricedCoverage.charge.currencyCode, this._otaPricedCoverage.charge.calculation.total);

            ////total the selected equipment
            //for (var eq in this._otaPricedEquips) {
            //    this.totalCurrencyCost(this._otaPricedEquips[eq].charge.currencyCode, this._otaPricedEquips[eq].requestedCount * this._otaPricedEquips[eq].charge.calculation.total);
            //}
            this._isNew = (this._be.eventMode == enumBusinessEventMode.beMode_Create);
            this._rentalChanged = this._be.rentalChanged;
            this._reference = (this._be.reference == null ? "" : this._be.reference);

            //ensure we're positioned at the top of the page
            window.scroll(0, 0);

            this.validateForm();
        }
    }

    private createOTARequest(): OTA_Request {
        //construct the OTA Request object for the current business event
        let otaReq: OTA_Request = new OTA_Request(enumRequestType.reqType_VehAvailRate);

        try {
            const millisecondsPerMinute = 60000;
            if (this._be.dateTimeOut != null) {
                var offsetDateTimeOut: Date = new Date(this._be.dateTimeOut.valueOf() - (this._be.dateTimeOut.getTimezoneOffset() * millisecondsPerMinute));
                otaReq.otA_VehAvailRateRQ.vehAvailRQCore.vehRentalCore.pickUpDateTime = offsetDateTimeOut;
            }
            if (this._be.dateTimeIn != null) {
                var offsetDateTimeIn: Date = new Date(this._be.dateTimeIn.valueOf() - (this._be.dateTimeIn.getTimezoneOffset() * millisecondsPerMinute));
                otaReq.otA_VehAvailRateRQ.vehAvailRQCore.vehRentalCore.returnDateTime = offsetDateTimeIn;
            }

            otaReq.otA_VehAvailRateRQ.vehAvailRQCore.vehRentalCore.pickUpLocation.locationCode = this._be.locationOut.code;
            otaReq.otA_VehAvailRateRQ.vehAvailRQCore.vehRentalCore.returnLocation.locationCode = this._be.locationIn.code;

            var otaVehPref: OTA_VehPref = new OTA_VehPref();
            otaVehPref.code = this._be.otaVehAvail.vehAvailCore.vehicle.code;
            otaVehPref.codeContext = "SIPP";
            otaVehPref.vehType.vehicleCategory = OTA_VehType.categoryFromEraVehicleType(this._be.vehicleType.vehicleTypeId);
            otaReq.otA_VehAvailRateRQ.vehAvailRQCore.vehPrefs.push(otaVehPref);
            otaReq.otA_VehAvailRateRQ.vehAvailRQCore.driverType.code = 1;
            otaReq.otA_VehAvailRateRQ.vehAvailRQCore.driverType.age = this._be.ageRange.ageApplied;
            otaReq.otA_VehAvailRateRQ.vehAvailRQCore.driverType.quantity = 1;

            if ((this._be.promoCode != null) 
                && (this._be.promoCode.trim().length > 0)) {

                switch (this._be.promotionType.promotionTypeId) {
                    case enumPromotionType.ptCustomerId:
                        //Customer ID
                        otaReq.otA_VehAvailRateRQ.vehAvailRQCore.rateQualifier.corpDiscountNmbr = this._be.promoCode.trim();
                        break;
                
                    case enumPromotionType.ptPromoCode:
                        //PromotionCode 
                        otaReq.otA_VehAvailRateRQ.vehAvailRQCore.rateQualifier.promotionCode = this._be.promoCode.trim();
                        break;
                }
            }

            this._be.otaVehAvail.vehAvailCore.pricedEquips.filter(eq => eq.requestedCount > 0).forEach(function (eq) {
                var otaSpecEqPref: OTA_SpecialEquipPref = new OTA_SpecialEquipPref();
                otaSpecEqPref.equipType = eq.equipment.equipType;
                otaSpecEqPref.quantity = eq.requestedCount;
                otaReq.otA_VehAvailRateRQ.vehAvailRQCore.specialEquipPrefs.push(otaSpecEqPref);
            });

            this._be.otaVehAvail.vehAvailInfo.pricedCoverages.filter(cvr => cvr.selected).forEach(function (cvr) {
                var otaCvrPref: OTA_CoveragePref = new OTA_CoveragePref();
                otaCvrPref.coverageType = cvr.coverageType;
                otaReq.otA_VehAvailRateRQ.vehAvailRQInfo.coveragePrefs.push(otaCvrPref);
            });

            if (this._be.hasDelivery) {
                let delivery: OTA_OffLocService = new OTA_OffLocService();
                delivery.type = "VehDelivery";
                delivery.address.addressLines.push(this._be.deliveryAddress);
                otaReq.otA_VehAvailRateRQ.vehAvailRQInfo.offLocServices.push(delivery);
            }

            if (this._be.hasCollection) {
                let collection: OTA_OffLocService = new OTA_OffLocService();
                collection.type = "VehCollection";
                collection.address.addressLines.push(this._be.collectionAddress);
                otaReq.otA_VehAvailRateRQ.vehAvailRQInfo.offLocServices.push(collection);
            }
        }
        catch (e) {
            console.log(e);
        }

        return otaReq;
    }

    private save(validateStep: boolean = true, action: number = 1): boolean {
        if (this._hasError) {
            return false;
        }

        this._be.rentingentity.firstName = this._firstName;
        this._be.rentingentity.principalName = this._lastName;

        var dob;
        if ((this._dob != null) && (this._dob.length > 0)) {
            dob = new Date(this._dob);
        }
        this._be.rentingentity.dateofBirth = dob;

        this._be.flightNumber = this._arrivalNo;

        //save the email Identification
        if (this._emailIdentification != null) {
            //update the existing email address object
            this._emailIdentification.membershipNumber = this._email;
            this._emailIdentification.allowNotification = this._emailSubscription;
        }
        else {
            //create a new email address object
            var newEmailIdent: Identification = new Identification();
            newEmailIdent.membershipNumber = this._email;
            newEmailIdent.identStatus = enumIdentStatus.idStatus_Valid;
            newEmailIdent.identType = enumIdentType.idType_Email;
            newEmailIdent.allowNotification = this._emailSubscription;
            this._be.rentingentity.identList.push(newEmailIdent);
        }

        //save the DL Identification
        if (this._dlIdentification != null) {
            //update the existing DL object
            this._dlIdentification.membershipNumber = this._dlNumber;
            var dlExp;
            if ((this._dlExpiry != null) && (this._dlExpiry.length > 0)) {
                dlExp = new Date(this._dlExpiry);
            }
            this._dlIdentification.expiry = dlExp;
        }
        else {
            //create a new DL object
            var newDLIdent: Identification = new Identification();
            newDLIdent.membershipNumber = this._dlNumber;
            newDLIdent.identStatus = enumIdentStatus.idStatus_Valid;
            newDLIdent.identType = enumIdentType.idType_DriversLicense;
            var dlExp;
            if ((this._dlExpiry != null) && (this._dlExpiry.length > 0)) {
                dlExp = new Date(this._dlExpiry);
            }
            newDLIdent.expiry = dlExp;
            this._be.rentingentity.identList.push(newDLIdent);
        }

        //save the phone
        if (this._phone != null) {
            //update the existing phone object
            this._phone.phoneNumber = this._phoneNumber;
        }
        else {
            //create a new phone object
            var newPhone: Phone = new Phone();
            newPhone.phoneNumber = this._phoneNumber;
            newPhone.phoneType = enumPhoneType.phnTypeContacts;
            this._be.rentingentity.phoneList.push(newPhone);
        }

        //save the addrees
        if (this._address != null) {
            //update the existing address object
            this._address.addressLine1 = this._addressLine;
            this._address.city = this._addressCity;
            this._address.state = this._addressState;
            this._address.zipCode = this._addressZipCode;
        }
        else {
            //create a new address object
            var newAddress: Address = new Address();
            newAddress.addressLine1 = this._addressLine;
            newAddress.city = this._addressCity;
            newAddress.state = this._addressState;
            newAddress.zipCode = this._addressZipCode;
            newAddress.addressTypeId = enumAddressType.addrTypeLocal
            this._be.rentingentity.address = newAddress;
        }

        this._be.eventAction = action;
        this._be.rentalChanged = (this._be.rentalChanged || this._hasChanged);

        this._beDataService.setBusinessEventForStep(this._currentStep, this._be, 0, validateStep);
        return true;
    }

    private saveOTAAvail(): boolean {
        this._otaAvail.vehAvailCore.pricedEquips.filter(eq => eq.charge.includedInEstTotalInd).forEach(function (eq) {
            eq.requestedCount = eq.equipment.quantity;
        });

        if (this._otaAvail.vehAvailInfo.pricedCoverages.length > 0) {
            var useDflt: boolean = true;

            //deselect all coverages
            this._otaAvail.vehAvailInfo.pricedCoverages.forEach(function (cvr) {
                cvr.selected = false;

                if ((cvr.charge.includedInEstTotalInd) && (!cvr.charge.includedInRate)) {
                    cvr.selected = true;
                    useDflt = false;
                }
            });

            if (useDflt) {
                this._otaAvail.vehAvailInfo.pricedCoverages.filter(cvr => ((cvr.charge.includedInEstTotalInd) && (cvr.charge.includedInRate))).forEach(function (cvr) {
                    cvr.selected = true;
                });
            }
        }


        this._be.otaVehAvail = this._otaAvail;
        this._beDataService.setBusinessEventForStep(this._currentStep, this._be, 0, false);
        return true;
    }

    private goToPreviousOnError() {
        this.navigateTo(this._previousStep);
    }

    private goToPrevious(step: string = "") {
        var proceed = true;

        if (step.length == 0)
            step = this._previousStep;

        if (this._hasChanged) {
            if (this._hasError) {
                //clear the Dialog object's array of DialogButtons
                this._dialog.buttons = [];

                //apply the required buttons to the Dialog object
                var btnYes: DialogButton = new DialogButton();
                btnYes.label = "Yes";
                btnYes.buttonType = enumDialogButtonType.dlgParam_Yes;
                this._dialog.buttons.push(btnYes);

                var btnNo: DialogButton = new DialogButton();
                btnNo.label = "No";
                btnNo.buttonType = enumDialogButtonType.dlgParam_No;
                this._dialog.buttons.push(btnNo);

                this._confirmationService.confirm({
                    message: 'The data has changed.<BR/>Do you wish to proceed and lose these changes?',
                    accept: () => {
                        switch (this._dialog.buttonPressed.buttonType) {
                            case enumDialogButtonType.dlgParam_Yes:
                                this._beDataService.changeStep(this._currentStep, false);
                                this.navigateTo(step);
                                break;
                            case enumDialogButtonType.dlgParam_No:
                                //this._beDataService.setCurrentStep(this._currentStep);
                                break;
                        }
                    }
                });
            }
            else {
                //clear the Dialog object's array of DialogButtons
                this._dialog.buttons = [];

                //apply the required buttons to the Dialog object
                var btnYes: DialogButton = new DialogButton();
                btnYes.label = "Yes";
                btnYes.buttonType = enumDialogButtonType.dlgParam_Yes;
                this._dialog.buttons.push(btnYes);

                var btnNo: DialogButton = new DialogButton();
                btnNo.label = "No";
                btnNo.buttonType = enumDialogButtonType.dlgParam_No;
                this._dialog.buttons.push(btnNo);

                var btnCancel: DialogButton = new DialogButton();
                btnCancel.label = "Cancel";
                btnCancel.buttonType = enumDialogButtonType.dlgParam_Cancel;
                this._dialog.buttons.push(btnCancel);

                this._confirmationService.confirm({
                    message: 'The data has changed.<BR/>Do you wish to save it?',
                    accept: () => {
                        switch (this._dialog.buttonPressed.buttonType) {
                            case enumDialogButtonType.dlgParam_Yes:
                                if (this.save(false, 1)) {
                                    this.navigateTo(step);
                                }
                                break;
                            case enumDialogButtonType.dlgParam_No:
                                this._beDataService.changeStep(this._currentStep, false);
                                this.navigateTo(step);
                                break;
                            case enumDialogButtonType.dlgParam_Cancel:
                                break;
                        }
                    },
                });
            }
        }
        else
            this.navigateTo(step);
    }

    private goToNext(action: number) {
        if (action == enumBusinessEventAction.beAction_Cancel) {
            //clear the Dialog object's array of DialogButtons
            this._dialog.buttons = [];

            //apply the required buttons to the Dialog object
            var btnYes: DialogButton = new DialogButton();
            btnYes.label = "Yes";
            btnYes.buttonType = enumDialogButtonType.dlgParam_Yes;
            this._dialog.buttons.push(btnYes);

            var btnNo: DialogButton = new DialogButton();
            btnNo.label = "No";
            btnNo.buttonType = enumDialogButtonType.dlgParam_No;
            this._dialog.buttons.push(btnNo);

            this._confirmationService.confirm({
                message: 'Are you sure you want to cancel the booking?',
                accept: () => {
                    switch (this._dialog.buttonPressed.buttonType) {
                        case enumDialogButtonType.dlgParam_Yes:
                            if (this.save(true, action)) {
                                //navigate to the next page
                                this.navigateTo(this._nextStep);
                            } break;
                        case enumDialogButtonType.dlgParam_No:
                            break;
                    }
                }
            });
        }
        else {
            this._doValidation = true;
            this.validateForm();

            if (this._hasError)
                return false;

            if (this.save(true, action)) {
                //navigate to the next page
                this.navigateTo(this._nextStep);
            }
        }
    }

    private navigateTo(step: string) {
        //navigate to the given page
        if (step.trim().length > 0)
            this._router.navigate(['/' + step]);
    }

    //
    //validation methods
    //
    private validateForm() {
        var dlExpiryChanged = false;
        var dobChanged = false;
        var dob;
        var dlExpiry;

        //Post-process entered values if required
        if (this._firstName != null)
            this._firstName = this._firstName.trim();
        if (this._lastName != null)
            this._lastName = this._lastName.trim();
        if (this._email != null)
            this._email = this._email.trim();
        if (this._confirmEmail != null)
            this._confirmEmail = this._confirmEmail.trim();
        if (this._phoneNumber != null)
            this._phoneNumber = this._phoneNumber.trim();
        if (this._arrivalNo != null)
            this._arrivalNo = this._arrivalNo.trim();
        if (this._dlNumber != null)
            this._dlNumber = this._dlNumber.trim();
        if (this._addressLine != null)
            this._addressLine = this._addressLine.trim();
        if (this._addressCity != null)
            this._addressCity = this._addressCity.trim();
        if (this._addressState != null)
            this._addressState = this._addressState.trim();
        if (this._addressZipCode != null)
            this._addressZipCode = this._addressZipCode.trim();

        if ((this._dob != null) && (this._dob.length > 0)) {
            dob = new Date(this._dob);
            if (this._be.rentingentity.dateofBirth != null) {
                dobChanged = (this._dob != this._be.rentingentity.dateofBirth.toString().split('T')[0]);
            }
            else
                dobChanged = true;
        }
        else {
            dobChanged = (this._be.rentingentity.dateofBirth != null);
        }

        if ((this._dlExpiry != null) && (this._dlExpiry.length > 0)) {
            dlExpiry = new Date(this._dlExpiry);

            if ((this._dlIdentification != null) && (this._dlIdentification.expiry != null)) {
                dlExpiryChanged = (this._dlExpiry != this._dlIdentification.expiry.toString().split('T')[0]);
            }
            else
                dlExpiryChanged = true;
        }
        else {
            dlExpiryChanged = ((this._dlIdentification != null) && (this._dlIdentification.expiry != null));
        }

        this._validationErrorMsgs.length = 0;

        //Validate each individual entry
        //the FirstName must be entered
        this._hasFirstNameError = ((this._firstName == null)
            || (this._firstName.length == 0));
        //the LastName must be entered
        this._hasLastNameError = ((this._lastName == null)
            || (this._lastName.length == 0));
        //the DOB must be entered (maybe?)
        this._hasDOBError = ((dob == null)
            && (this._mandatoryDOB));
        //the Email & ConfirmEmail must be entered and match
        this._hasEmailError = ((this._email.length == 0)
            || (this._email.toUpperCase() != this._confirmEmail.toUpperCase())
            || (!this.validateEmail(this._email)));
        //the DL Expiry must be entered (maybe?)
        this._hasDLError = (this._mandatoryDL && ((this._dlNumber == null) || (this._dlNumber.length == 0)));
        //the DL Expiry must be entered if there is a DL Number
        this._hasDLExpiryError = ((this._dlNumber != null) && (this._dlNumber.length > 0) && (dlExpiry == null));

        this._dlNumber

        //the PhoneNumber must be entered
        this._hasPhoneNumberError = ((this._phoneNumber == null)
            || (this._phoneNumber.length == 0));

        //the ArrivalNumber must be entered (if the Out location is an airport)
        this._hasArrivalNumberError = ((this._be.locationOut.isAirport)
            && ((this._arrivalNo == null) || (this._arrivalNo.length == 0)));

        //the AddressLine must be entered
        this._hasAddressLineError = (this._mandatoryAddress
            && ((this._addressLine == null) || (this._addressLine.length == 0) ));

        //the AddressCity must be entered
        this._hasAddressCityError = (this._mandatoryAddress
            && ((this._addressCity == null) || (this._addressCity.length == 0)));

        //the ArrivalNumber must be entered (if the Out location is an airport)
        this._hasArrivalNumberError = ((this._be.locationOut.isAirport)
            && ((this._arrivalNo == null) || (this._arrivalNo.length == 0)));


        //check if any parameter has been changed from the original value
        this._hasChanged = ((this._firstName != this._be.rentingentity.firstName)
            || (this._lastName != this._be.rentingentity.principalName)
            || (dobChanged)
            || ((this._emailIdentification == null) && ((this._email.length > 0) || (this._emailSubscription)))
            || ((this._emailIdentification != null) && ((this._email != this._emailIdentification.membershipNumber) || (this._emailSubscription != this._emailIdentification.allowNotification)))
            || ((this._dlIdentification == null) && (this._dlNumber.length > 0))
            || ((this._dlIdentification != null) && (this._dlNumber != this._dlIdentification.membershipNumber))
            || ((this._dlIdentification != null) && (this._dlNumber == this._dlIdentification.membershipNumber) && (dlExpiryChanged))
            || ((this._phone == null) && (this._phoneNumber.length > 0))
            || ((this._phone != null) && (this._phoneNumber != this._phone.phoneNumber))
            || ((this._address == null) && (this._addressLine.length > 0))
            || ((this._address != null) && (this._addressLine != this._address.addressLine1))
            || ((this._address != null) && (this._addressCity != this._address.city))
            || ((this._address != null) && (this._addressState != this._address.state))
            || ((this._address != null) && (this._addressZipCode != this._address.zipCode))
            || (this._arrivalNo != this._be.flightNumber));
        this._rentalChanged = (this._be.rentalChanged || this._hasChanged);

        this._beDataService.changeStep(this._currentStep, this._hasChanged);

        //check if the form is good to be submitted
        this._hasError = ((this._nextStep.length == 0)
            || (this._previousStep.length == 0)
            || (this._hasFirstNameError)
            || (this._hasLastNameError)
            || (this._hasDOBError)
            || (this._hasEmailError)
            || (this._hasDLError)
            || (this._hasDLExpiryError)
            || (this._hasPhoneNumberError)
            || (this._hasAddressLineError)
            || (this._hasAddressCityError)
            || (this._hasAddressStateError)
            || (this._hasAddressZipCodeError)
            || (this._hasArrivalNumberError));

        this._hasSubmitError = (this._hasError && (this._validationMode == enumValidationMode.valmode_Immediate));

        this._firstNameTextColour = (this._hasFirstNameError && this._doValidation) ? this._invalidTextColour : this._textColour;
        this._firstNameBorderColour = (this._hasFirstNameError && this._doValidation) ? this._invalidBorderColour : "";
        this._lastNameTextColour = (this._hasLastNameError && this._doValidation) ? this._invalidTextColour : this._textColour;
        this._lastNameBorderColour = (this._hasLastNameError && this._doValidation) ? this._invalidBorderColour : "";
        this._dobTextColour = (this._hasDOBError && this._doValidation) ? this._invalidTextColour : this._textColour;
        this._dobBorderColour = (this._hasDOBError && this._doValidation) ? this._invalidBorderColour : "";
        this._emailTextColour = (this._hasEmailError && this._doValidation) ? this._invalidTextColour : this._textColour;
        this._emailBorderColour = (this._hasEmailError && this._doValidation) ? this._invalidBorderColour : "";
        this._dlNumberTextColour = (this._hasDLError && this._doValidation) ? this._invalidTextColour : this._textColour;
        this._dlNumberBorderColour = (this._hasDLError && this._doValidation) ? this._invalidBorderColour : "";
        this._dlExpiryTextColour = (this._hasDLExpiryError && this._doValidation) ? this._invalidTextColour : this._textColour;
        this._dlExpiryBorderColour = (this._hasDLExpiryError && this._doValidation) ? this._invalidBorderColour : "";
        this._phoneTextColour = (this._hasPhoneNumberError && this._doValidation) ? this._invalidTextColour : this._textColour;
        this._phoneBorderColour = (this._hasPhoneNumberError && this._doValidation) ? this._invalidBorderColour : "";
        this._addressLineTextColour = (this._hasAddressLineError && this._doValidation) ? this._invalidTextColour : this._textColour;
        this._addressLineBorderColour = (this._hasAddressLineError && this._doValidation) ? this._invalidBorderColour : "";
        this._addressCityTextColour = (this._hasAddressCityError && this._doValidation) ? this._invalidTextColour : this._textColour;
        this._addressCityBorderColour = (this._hasAddressCityError && this._doValidation) ? this._invalidBorderColour : "";
        this._addressStateTextColour = (this._hasAddressStateError && this._doValidation) ? this._invalidTextColour : this._textColour;
        this._addressStateBorderColour = (this._hasAddressStateError && this._doValidation) ? this._invalidBorderColour : "";
        this._addressZipCodeTextColour = (this._hasAddressZipCodeError && this._doValidation) ? this._invalidTextColour : this._textColour;
        this._addressZipCodeBorderColour = (this._hasAddressZipCodeError && this._doValidation) ? this._invalidBorderColour : "";
        this._arrivalTextColour = (this._hasArrivalNumberError && this._doValidation) ? this._invalidTextColour : this._textColour;
        this._arrivalBorderColour = (this._hasArrivalNumberError && this._doValidation) ? this._invalidBorderColour : "";

        if (this._hasFirstNameError)
            this._validationErrorMsgs.push("First Name");
        if (this._hasLastNameError)
            this._validationErrorMsgs.push("Last Name");
        if (this._hasDOBError)
            this._validationErrorMsgs.push("Date of Birth");
        if (this._hasEmailError)
            this._validationErrorMsgs.push("Email");
        if (this._hasDLError)
            this._validationErrorMsgs.push("Drivers Licence");
        if (this._hasDLExpiryError)
            this._validationErrorMsgs.push("Drivers Licence Expiry");
        if (this._hasPhoneNumberError)
            this._validationErrorMsgs.push("Phone Number");
        if (this._hasAddressLineError)
            this._validationErrorMsgs.push("Address Line");
        if (this._hasAddressCityError)
            this._validationErrorMsgs.push("Address City");
        if (this._hasAddressStateError)
            this._validationErrorMsgs.push("Address State");
        if (this._hasAddressZipCodeError)
            this._validationErrorMsgs.push("Address Postal Code");
        if (this._hasArrivalNumberError)
            this._validationErrorMsgs.push("Arrival Number");
    }

    private validateEmail(eml: string): boolean {
        var EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (!EMAIL_REGEXP.test(eml)) {
            return false;
        }
        return true;
    }

    //
    //helper methods
    //
    private formatChargeTotal(chg: OTA_Charge, payNow: boolean = false): string {
        let cost: CurrencyAmount = new CurrencyAmount();

        cost.amount = OTA_Charge.chargeTotal(chg);
        if (payNow) {
            cost.amount = cost.amount * 0.9;
        }

        cost.currencyCode = chg.currencyCode;

        return this._configDataService.formatCurrencyAmount(cost);
    }

    private formatFeeTotal(fee: OTA_Fee): string {
        let cost: CurrencyAmount = new CurrencyAmount();
        cost.amount = OTA_Fee.feeTotal(fee);
        cost.currencyCode = fee.currencyCode;

        return this._configDataService.formatCurrencyAmount(cost);
    }

    private formatPricedEquipTotal(eq: OTA_PricedEquip): string {
        let cost: CurrencyAmount = new CurrencyAmount();
        cost.amount = eq.requestedCount * OTA_PricedEquip.pricedEquipTotal(eq) / eq.equipment.quantity;
        cost.currencyCode = eq.charge.currencyCode;

        return this._configDataService.formatCurrencyAmount(cost);
    }

    private formatCurrencyTotal(currAmount: CurrencyAmount): string {
        return this._configDataService.formatCurrencyAmount(currAmount);
    }

    private totalCurrencyCost(currencyCode: string, amount: number)
    {
        var currAmnt = this._totalCosts.find(x => (x.currencyCode == currencyCode));
        if (currAmnt == null) {
            currAmnt = new CurrencyAmount()
            currAmnt.currencyCode = currencyCode;
            currAmnt.amount = 0;
            this._totalCosts.push(currAmnt);
        }
        currAmnt.amount = currAmnt.amount + amount;
    }

    private vehicleImageURL(vehAvail: OTA_VehAvail): string {
        var imageURL = ""

        if ((vehAvail != null)
            && (vehAvail.vehAvailCore != null)
            && (vehAvail.vehAvailCore.vehicle != null)) {

            //imageURL = vehAvail.vehAvailCore.vehicle.vehicleImageRef;
            imageURL = vehAvail.vehAvailCore.vehicle.code + ".png";

            if (imageURL.length > 0)
                imageURL = this._baseVehImgURL + imageURL;
        }

        return imageURL;
    }

    private onImgError(event) {
        event.target.src = this._baseVehImgURL + "Coming_Soon.png";
    }

    //
    //dialog management
    //
    private dialogButtonPressed(button: DialogButton) {
        //record which button was pressed
        this._dialog.buttonPressed = button;
    }

    private unsubscribe() {
        this._subscriptions.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
        this._subscriptions = [];
    }
}

